import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import SidebarCalendar from './SidebarCalendar';

const Sidebar = ({
  calendars,
  deselectedSchedules,
  onCalendarToggle,
  onScheduleToggle,
  schedules
}) => (
  <div className='appointment-list-sidebar'>
    <div className='appointment-list-filter-header'>Filter list by:</div>

    {
      calendars.map((calendar) => (
        <SidebarCalendar
          calendar={calendar}
          deselectedSchedules={deselectedSchedules}
          schedules={
            useMemo(() => schedules.filter(
              (schedule) => schedule.calendar_id === calendar.id
            ), [calendar, schedules])
          }
          onCalendarToggle={onCalendarToggle}
          onScheduleToggle={onScheduleToggle}
          key={calendar.id}
        />
      ))
    }
  </div>
);

Sidebar.propTypes = {
  /** A list of calendars */
  calendars: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),

  /** A list of schedules which have been deselected */
  deselectedSchedules: PropTypes.arrayOf(PropTypes.string),

  /** Method called when toggling the selection of a calendar */
  onCalendarToggle: PropTypes.func,

  /** Method called when toggling the selection of a schedule */
  onScheduleToggle: PropTypes.func,

  /** A list of schedules */
  schedules: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    calendar_id: PropTypes.string
  }))
};

Sidebar.defaultProps = {
  calendars: [],
  deselectedSchedules: [],
  schedules: [],

  onCalendarToggle: () => false,
  onScheduleToggle: () => false
};

export default Sidebar;
